<template>
  <div class="immunity-btns-container">
    <b-button 
      v-if="immunities.includes('f')"
      :id="'fire-immunity-btn-'+id"
      class="immunity-pill"
      :variant="variant"
      @click="clickImmunityBtn('Fire')"
    >
      <img alt="Immunity to fire" src="../assets/fire.svg">
    </b-button>
    <b-tooltip v-if="immunities.includes('f') && !isModalVisible" :target="'fire-immunity-btn-'+id" triggers="hover">
      {{ $t('immunity.monstersImmunity') }}: {{ $t('immunity')['Fire'] }} <br/>
      {{ $t('common.clickForDetails') }}
    </b-tooltip>
    <b-button
      v-if="immunities.includes('c')"
      :id="'cold-immunity-btn-'+id"
      class="immunity-pill"
      :variant="variant"
      @click="clickImmunityBtn('Cold')"
    >
      <img alt="Immunity to cold" src="../assets/snow.svg">
    </b-button>
    <b-tooltip v-if="immunities.includes('c') && !isModalVisible" :target="'cold-immunity-btn-'+id" triggers="hover">
      {{ $t('immunity.monstersImmunity') }}: {{ $t('immunity')['Cold'] }} <br/>
      {{ $t('common.clickForDetails') }}
    </b-tooltip>
    <b-button
      v-if="immunities.includes('l')"
      :id="'lightning-immunity-btn-'+id"
      class="immunity-pill"
      :variant="variant"
      @click="clickImmunityBtn('Lightning')"
    >
      <img alt="Immunity to lightning" src="../assets/lightning.svg">
    </b-button>
    <b-tooltip v-if="immunities.includes('l') && !isModalVisible" :target="'lightning-immunity-btn-'+id" triggers="hover">
      {{ $t('immunity.monstersImmunity') }}: {{ $t('immunity')['Lightning'] }} <br/>
      {{ $t('common.clickForDetails') }}
    </b-tooltip>
    <b-button
      v-if="immunities.includes('p')"
      :id="'poison-immunity-btn-'+id"
      class="immunity-pill"
      :variant="variant"
      @click="clickImmunityBtn('Poison')"
    >
      <img alt="Immunity to poison" src="../assets/skull.svg">
    </b-button>
    <b-tooltip v-if="immunities.includes('p') && !isModalVisible" :target="'poison-immunity-btn-'+id" triggers="hover">
      {{ $t('immunity.monstersImmunity') }}: {{ $t('immunity')['Poison'] }} <br/>
      {{ $t('common.clickForDetails') }}
    </b-tooltip>
    <b-button
      v-if="immunities.includes('ph')"
      :id="'physical-immunity-btn-'+id"
      class="immunity-pill"
      :variant="variant"
      @click="clickImmunityBtn('Physical')"
    >
      <img alt="Immunity to physical" src="../assets/sword.svg">
    </b-button>
    <b-tooltip v-if="immunities.includes('ph') && !isModalVisible" :target="'physical-immunity-btn-'+id" triggers="hover">
      {{ $t('immunity.monstersImmunity') }}: {{ $t('immunity')['Physical'] }} <br/>
      {{ $t('common.clickForDetails') }}
    </b-tooltip>
    <b-button
      v-if="immunities.includes('m')"
      :id="'magic-immunity-btn-'+id"
      class="immunity-pill"
      :variant="variant"
      @click="clickImmunityBtn('Magic')"
    >
      <img alt="Immunity to magic" src="../assets/magic.svg">
    </b-button>
    <b-tooltip v-if="immunities.includes('m') && !isModalVisible" :target="'magic-immunity-btn-'+id" triggers="hover">
      {{ $t('immunity.monstersImmunity') }}: {{ $t('immunity')['Magic'] }} <br/>
      {{ $t('common.clickForDetails') }}
    </b-tooltip>
    <b-modal
      v-if="areas.length > 0"
      v-model="isModalVisible"
      :title-html="modalTitle"
      header-bg-variant="dark"
      header-text-variant="light"
      body-bg-variant="dark"
      body-text-variant="light"
      body-class="monster-image"
      footer-bg-variant="dark"
      footer-text-variant="light"
      ok-only
      ok-title="OK"
      hideHeaderClose
    >
      <div v-for="(immunities, area) in monsters" :key='area'>
        <p class="area-title">
          {{ areaName[area][language] }}
        </p>
        <p v-if="!immunities[selectedImmunity]" class="monsters-area monsters-area-text">
          ({{ $t('common.none') }})
        </p>
        <p v-else class="monsters-area">
          <span v-for="(monster, index) in immunities[selectedImmunity]" :key='index'>
            <img
              :id="'img-' + area + '-' + monster"
              :src="getImageUrl(area, monster)"
              class="mx-4 my-2"
            >
            <b-tooltip :target="'img-' + area + '-' + monster" triggers="hover click">
              {{ monster }}
            </b-tooltip>
          </span>
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { immunitiesData } from '@/utils/immunities'
import { areaData } from '@/utils/area_data'

export default {
  name: 'Immunities',

  data() {
    return {
      isModalVisible: false,
      selectedImmunity: null
    }
  },

  props: {
    id: {
      type: String,
      required: true
    },

    language: {
      type: String,
      required: true
    },

    immunities: {
      type: Array,
      default: () => ['f', 'c', 'l', 'p', 'ph', 'm']
    },

    areas: {
      type: Array,
      default: () => []
    },

    variant: {
      type: String,
      default: 'dark'
    },
  },

  computed: {
    modalTitle () {
      if (!this.selectedImmunity) {
        return '';
      }
      const immunityText = this.$t('immunity')[this.selectedImmunity];
      const immunityHtml = `<b class="${this.selectedImmunityTextClass}">${immunityText}</b>`;
      return this.$t('immunity.modalTitle', { immunity: immunityHtml });
    },

    selectedImmunityTextClass () {
      return this.selectedImmunity ? `${this.selectedImmunity.toLowerCase()}-text` : '';
    },

    areaName () {
      return areaData;
    },

    monsters () {
      const monsters = {};
      this.areas.forEach((area) => {
        if (immunitiesData[area]) {
          monsters[area] = immunitiesData[area];
        }
      });
      return monsters;
    }
  },

  methods: {
    clickImmunityBtn (immunity) {
      this.selectedImmunity = immunity;
      this.isModalVisible = true;
    },

    getImageUrl (area, monster) {
      return `immunities/${area}/${this.selectedImmunity}/${monster}.gif`;
    }
  },
}
</script>

<style scoped>
.immunity-pill {
  height: 24px;
  padding: 0em 0.3em;
  margin: 0em 0.1em;
  border-radius: 10rem;
}
.immunity-pill img {
  width: 14px;
  height:14px;
  margin-top: -4px;
}
.area-title {

}
.monsters-area {
  min-height: 50px;
  border-style: solid;
  border-color: #555;
  background-color: #000;
}
.monsters-area-text {
  text-align: center;
  font-size: 24px;
}
</style>